import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { cgToast, notifyError } from 'modules/Common/ui/toast';
import {
  acceptSupplierConnection,
  acceptSupplierConnectionAndRequest,
  acceptSupplierRequest,
  cancelSupplierRequest,
  declineSupplierConnection,
  declineSupplierRequest,
  fetchSupplierInbox,
  terminateSupplierConnection,
} from './supplierInboxApi';

export const SUPPLIER_INBOX_QUERY_KEY = ['supplierInbox'];

export const useSupplierInbox = ({ enabled = true } = {}) =>
  useQuery({
    queryKey: SUPPLIER_INBOX_QUERY_KEY,
    queryFn: fetchSupplierInbox,
    staleTime: 0,
    enabled,
  });

const useSupplierInboxMutation = (mutationFn, message) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: async () => {
      cgToast.success('Success', { description: message });
      await queryClient.invalidateQueries({ queryKey: SUPPLIER_INBOX_QUERY_KEY });
      // The paid-Operator shell badges the same inbox under its own key
      // (useFetchOperatorInviteCount) — refresh it too; no-op elsewhere.
      await queryClient.invalidateQueries({ queryKey: ['operatorInvites'] });
    },
    onError: notifyError,
  });
};

export const useSupplierInboxActions = () => {
  return {
    acceptConnection: useSupplierInboxMutation(acceptSupplierConnection, 'Connection accepted'),
    declineConnection: useSupplierInboxMutation(declineSupplierConnection, 'Connection declined'),
    terminateConnection: useSupplierInboxMutation(
      terminateSupplierConnection,
      'Connection terminated',
    ),
    acceptRequest: useSupplierInboxMutation(acceptSupplierRequest, 'Request accepted'),
    declineRequest: useSupplierInboxMutation(declineSupplierRequest, 'Request declined'),
    cancelRequest: useSupplierInboxMutation(cancelSupplierRequest, 'Request cancelled'),
    acceptConnectionAndRequest: useSupplierInboxMutation(
      acceptSupplierConnectionAndRequest,
      'Connection and request accepted',
    ),
  };
};
